
export default {
    namespaced: true,
    state: {
      navigationData: null,
       refreshTopicsFlag: 0,
    },
    mutations: {
      setNavigationData(state, data) {
        state.navigationData = data;
      },
      clearNavigationData(state) {
        state.navigationData = null;
      },
      triggerRefreshTopics(state) {
        state.refreshTopicsFlag++
      },
    },
    actions: {
      saveNavigationData({ commit }, data) {
        commit('setNavigationData', data);
      },
      resetNavigationData({ commit }) {
        commit('clearNavigationData');
      },
    },
    getters: {
      getNavigationData: (state) => state.navigationData,
    },
  };
  